var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlPrimaryLocked32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PrimaryLocked32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    opacity: 0,
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0,
    fill: "#D8D8D8",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#706D6E",
    cx: 16,
    cy: 16,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 7.000000)",
    id: "04-Honeycomb-Foundation/icon/Control/LogOn24",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconLogOn",
    transform: "translate(2.666667, 1.333333)",
    fill: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33333333,12.6666667 L1.33333333,12.6666667 L1.33333333,6.66666667 L9.33333333,6.66666667 L9.33333333,12.6666667 Z M3.33333333,3.576 C3.33333333,2.33933333 4.23066667,1.33333333 5.33333333,1.33333333 C6.436,1.33333333 7.33333333,2.33933333 7.33333333,3.576 L7.33333333,5.33333333 L3.33333333,5.33333333 L3.33333333,3.576 Z M8.66666667,5.33333333 L8.66666667,3.576 C8.66666667,1.604 7.17133333,0 5.33333333,0 C3.49533333,0 2,1.604 2,3.576 L2,5.33333333 L0,5.33333333 L0,14 L10.6666667,14 L10.6666667,5.33333333 L8.66666667,5.33333333 Z",
    id: "Locked"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlPrimaryLocked32);
export default __webpack_public_path__ + "static/media/controlPrimaryLocked32.1288758f4d9521faf5666cd80c697f83.svg";
export { ForwardRef as ReactComponent };